import React, { useContext, useState } from "react";
import { Button } from 'primereact/button';
import { apiRequest, formatFileSize, toast, url } from "@/Helpers/general";
import { AppContext } from "@/Components/Context/AppContext";
import { createStorageObject } from "@/Helpers/storage";
import FileUploadTemplate from "@/Components/Templates/Forms/FileUploadTemplate";
import { ExcelIcon } from "@/Helpers/svg-icons";

/**
 * Component which handles the "upload DACB spreadsheet" tab of creating a new claim
 */
const NewClaimDACBXlsForm = () => {
    const { toastRef } = useContext(AppContext);

    const [formLoading, setFormLoading] = useState(false);
    const [uploadDisabled, setUploadDisabled] = useState(false);
    const [mainFile, setMainFile] = useState();
    const [showMandatoryFileMsg, setShowMandatoryFileMsg] = useState(false);

    /**
     * Submits the new claim form
     */
    const submitForm = async () => {
        if (mainFile) {
            setShowMandatoryFileMsg(false);
            setFormLoading(true);

            let formData = new FormData();

            formData.append('mainFile', mainFile);

            apiRequest('post', 'request/xls/rubik', {
                data: formData,
                onSuccess: (response) => {
                    setFormLoading(false);

                    if (response?.data?.responseType === 'success') {
                        createStorageObject('flashMessages', [{
                            type: 'success',
                            title: 'Success',
                            message: 'The claim import process has started.'
                        }]);

                        window.location.replace(url('home'));

                    } else {
                        toast(toastRef, 'error', 'Error importing claims.');
                    }
                },
                onFailure: (error) => {
                    setFormLoading(false);
					if (error.messages) {
						if (error.messages.message) {
							toast(toastRef, 'error', error.messages.message);
						} else if (error.messages.mainFile) {
							for (let key in error.messages.mainFile) {
								toast(toastRef, 'error', error.messages.mainFile[key]);
							}
						} else {
							toast(toastRef, 'error', error.messages);
						}
					} else {
						toast(toastRef, 'error', 'Error importing claims.');
					}
                }
            });

        } else {
            setShowMandatoryFileMsg(true);
        }
    };

    /**
     * Add files in the state
     *
     * @param {object} event data related to the files
     */
    const uploadHandler = (event, type) => {
        switch (type) {
            case 'mainFile':
                setMainFile(event.files[0]);
                setShowMandatoryFileMsg(false);
                setUploadDisabled(true);
                break;

            default:
                break;
        }
    };

    /**
     * Remove a file from the state
     *
     * @param {object} event data related to the file
     */
    const onFileRemove = (event, type) => {

        switch (type) {
            case 'mainFile':
                setMainFile();
                setUploadDisabled(false);
                break;

            default:
                break;
        }

    };

    /**
     * The preview (for files other than images) which appears after you select a file
     */
    const itemTemplate = (file, event) => {
        return (
            <div className="p-fileupload-row other-files-format">
                <div className="file-extension-icon">
                    <ExcelIcon />
                </div>

                <div className="p-fileupload-filename">{file.name}</div>

                <div>{formatFileSize(file.size)}</div>

                <div>
                    <button type="button" className="p-button p-component p-button-icon-only" onClick={() => {
                        event.onRemove();
                        setMainFile();
                    }}>
                        <span className="p-button-icon p-c pi pi-times"></span>
                        <span className="p-button-label p-c">&nbsp;</span>
                    </button>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className="general-form">
                <div className="main-content grid">
                    <div className="col-6">
                        <label htmlFor="" className="block mb-3">DACB Xlsx file:</label>
                        <FileUploadTemplate uploadHandler={(e) => uploadHandler(e, 'mainFile')}
                            disabled={uploadDisabled}
                            multiple={false}
                            onFileRemove={(e) => onFileRemove(e, 'mainFile')}
                            accept=".xlsx"
                            itemTemplate={itemTemplate}
                        />
                        {showMandatoryFileMsg && <small className={'p-error block mt-1 w-full'}>Xlsx file is mandatory.</small>}
                    </div>
                </div>

                <hr />
                <div className="text-right">
                    <Button label="Save" onClick={submitForm} loading={formLoading} loadingIcon="pi pi-spin pi-sun" iconPos="center" />
                </div>
            </div>
        </>
    );
};

export default NewClaimDACBXlsForm;
